/// <amd-module name="CodeCoverage/CodeCoverageTab/Actions/CodeCoverageTabActionHub" />
import { Action } from "VSS/Reflux/Action";
import * as TCMContracts from 'Test/common-util/Contracts/Test';

export interface IBuildCodeCoverageDetails {
    buildConfigurations: TCMContracts.BuildConfiguration[];
    buildCoverages: IConfigCodeCoverageDetails[];
}

export interface IFolderViewBuildCodeCoverageDetails {
    buildConfigurations: TCMContracts.BuildConfiguration[];
    folderViewCoverages: IFolderViewCoverageDetails[];
}

export interface IFolderViewCoverageDetails {
    folderCoverageData: TCMContracts.FolderCoverageData;
    summaryViewProps: ICodeCoverageSummaryViewProps;
}

export interface IConfigCodeCoverageDetails {
    summaryViewProps: ICodeCoverageSummaryViewProps;
    codeCoverageModuleList: ICodeCoverageModuleDetails[];
    coverageDownloadLink: string
}

export interface ICodeCoverageModuleDetails {
    moduleName: string;
    moduleUrl: string;
    coveredLines: number;
    totalLines: number;
    lineCoverage: string;
}

export interface ICodeCoverageSummaryViewProps {
    moduleCount: number;
    totalLines: number;
    totalCoveredLines: number;
    coveragePercent: string;
}

export class CodeCoverageTabActionHub {
    public updateModuleFilterText = new Action<string>();
    public updateBuildConfigSelection = new Action<number>();
    public updateBuildCodeCoverage = new Action<IBuildCodeCoverageDetails>();
    public updateCodeCoverageSummary = new Action<string>();
    public updateNoCodeCoverageMessage = new Action<string>();
    public updateCodeCoverageFailureMessage = new Action<string>();
    public updateEnableFolderViewState = new Action<boolean>();
    public updateFolderViewBuildCodeCoverage = new Action<IFolderViewBuildCodeCoverageDetails>();
    public updateFolderViewBuildConfigSelection = new Action<number>();

    private constructor() {}

    public static getInstance(): CodeCoverageTabActionHub {

        if (!CodeCoverageTabActionHub._instance) {
            CodeCoverageTabActionHub._instance = new CodeCoverageTabActionHub();
        }

        return CodeCoverageTabActionHub._instance;
    }

    private static _instance: CodeCoverageTabActionHub;
}
